import React, { useCallback, useContext, useState } from 'react';
import SerializationCopy from '../../utils/SerializationCopy';
import FormBuilderAccessSettingView from '../view/FormBuilderAccessSettingView';
import { FormBuilderContext } from './FormBuilderEngine';

const FormBuilderAccessSettingEngine = () => {
  const [isAccessSettingDialogOpen, setIsAccessSettingDialogOpen] =
    useState(false);
  const [limitAccessGroups2Display, setLimitAccessGroups2Display] = useState(
    []
  );
  const { form } = useContext(FormBuilderContext);

  const onDialogStateChanged = useCallback(data => {
    setLimitAccessGroups2Display(
      SerializationCopy(data.initialLimitAccessGroups)
    );
  }, []);

  const viewProps = {
    isAccessSettingDialogOpen,
    setIsAccessSettingDialogOpen,
    onDialogStateChanged,
    limitAccessGroups2Display,
    isPublic: form.sharingType === 'anonymous'
  };

  return <FormBuilderAccessSettingView {...viewProps} />;
};

export default FormBuilderAccessSettingEngine;
